export default __webpack_public_path__ + "static/27-d0b7258febcc5e83ecdf6dec743a21f5.png";